// App.js
import React from 'react';
import AppRoutes from './AppRoutes';
import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => (
  <div className="d-flex flex-column min-vh-100">
    <main className="flex-grow-1">
      <AppRoutes />
    </main>
  </div>
);

export default App;
